import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
const Menu = () => {
    const [user, setUser] = useState([]);
    const Fetchdata = () => {
      fetch("https://www.themealdb.com/api/json/v1/1/categories.php")
        .then((Response) => Response.json())
        .then((data) => setUser(data.categories));
    };
    useEffect(() => {
      Fetchdata();
    });
  return (
    <>
    <section className="menu section bd-container" id="menu">
                <span className="section-subtitle">Special</span>
                <h2 className="section-title">Menu of the week</h2>

                <div className="menu__container bd-grid">
                    

                {user &&
        user.length > 0 &&
        user.map((value, index) => (
                    <div className="menu__content" key={index}>
                        <img src={value.strCategoryThumb} alt="" className="menu__img"/>
                        <h3 className="menu__name">{value.strCategory}</h3>
                        <span className="menu__detail">Delicious dish</span>
                        <span className="menu__preci">$22.00</span>
                        <Link to={value.strCategory} className="button menu__button"><i className='bx bx-right-arrow-alt'></i></Link>
                    </div>

        ))}
                </div>
            </section></>
  )
}

export default Menu